"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = exports.configDefaults = void 0;var _nuiConfig = _interopRequireDefault(require("@concur/nui-config"));function _interopRequireDefault(e) {return e && e.__esModule ? e : { default: e };}

var configDefaults = exports.configDefaults = {
  nui: {
    assets: {
      app: {
        useCDN: {
          value: false
        },
        path: {
          value: '/static'
        }
      },
      cdn: {
        url: {
          value: '//static.concursolutions.com'
        }
      }
    },
    DRCListingId: {
      value: '',
      clientExposed: true,
      useDefault: true
    },
    jouleListingId: {
      value: '',
      clientExposed: true,
      useDefault: true
    },
    log: {
      application: {
        value: 'appcenter-web',
        useDefault: true
      },
      roletype: {
        value: 'appc',
        useDefault: true
      },
      version: {
        value: '1.0.0',
        useDefault: true
      }
    },
    branch: {
      value: 'appcenter',
      clientExposed: true
    },
    categoryDropdownThreshold: {
      value: 20,
      clientExposed: true,
      useDefault: true
    },
    endorsedCategoryEnabled: {
      value: true,
      clientExposed: true,
      useDefault: true
    },
    baseUrl: {
      value: '/nui/appcenter',
      clientExposed: true
    },
    x509: {
      key: {
        value: '',
        useDefault: true
      },
      cert: {
        value: '',
        useDefault: true
      }
    },
    // NUI_ENABLEINCOMPLETEDNFCONNECTIONBLOCKING
    enableIncompleteDnfConnectionBlocking: {
      value: false,
      clientExposed: true,
      useDefault: true
    },
    // NUI_FORCEINCOMPLETEDNFCONNECTIONBLOCKING
    forceIncompleteDnfConnectionBlocking: {
      value: false,
      clientExposed: true,
      useDefault: true
    }
  },
  appcenterAPIBase: {
    client: {
      value: 'https://www-rqa3.api.nonprod.cnqr.tech/appcenter',
      clientExposed: true
    },
    server: {
      value: 'https://rqa3.api.nonprod.cnqr.tech/appcenter',
      clientExposed: false
    }
  },
  CTEUrl: {
    value: 'https://rqa3.nonprod.cnqr.tech',
    clientExposed: true
  },
  port: 3000,
  logger: {
    category: 'Web-API'
  },
  cookie_consent: {
    value: false,
    useDefault: true,
    clientExposed: true
  }
};var _default = exports.default =

(0, _nuiConfig.default)(configDefaults);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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